import React, { PropsWithChildren } from "react";

import { HistoryTableRowItemProps } from "../../../@types/rldynamicanalysis";

const HistoryTableRowItem: React.FC<
  PropsWithChildren<HistoryTableRowItemProps>
> = ({ children, className, onClick }) => (
  <td className={className} onClick={onClick}>
    {children}
  </td>
);

export default HistoryTableRowItem;
